import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`w100 FormFieldsListContent`),
  style: {}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fw600 fs14 pad10 dblue" }, "項目", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "fs14 ml10 fw600 fl",
  style: {"line-height":"50px","margin-bottom":"0"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "pad10" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "fw600 fs14 dblue mt4" }, "特殊フィールド", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "フォームに1つのみ設置することができます。特定の目的に利用するフィールドが特殊フィールドです。", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  class: "fs14 ml10 fw600 fl",
  style: {"line-height":"50px","margin-bottom":"0"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "fw600 fs14 pad10 dblue" }, "入力なしコンテンツ", -1)
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  class: "fs14 ml10 fw600 fl",
  style: {"line-height":"50px","margin-bottom":"0"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconLock = _resolveComponent("IconLock")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeArray, (fieldDic, fieldindex) => {
        return (_openBlock(), _createElementBlock("li", {
          key: fieldindex,
          onClick: ($event: any) => (_ctx.clickField(fieldDic)),
          class: "pointer",
          style: {"height":"50px","line-height":"50px","border":"1px solid #eee"}
        }, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(fieldDic.icon),
            class: "fl ml15 mt8",
            width: "28",
            height: "29"
          }, null, 8, _hoisted_4),
          _createElementVNode("p", _hoisted_5, _toDisplayString(fieldDic.name), 1),
          (fieldDic.field_type == `upload_file` && !_ctx.rm.canUseOption(`room_upload_file_in_form`, false))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_IconLock, {
                  style: {"margin-top":"15px","margin-right":"15px"},
                  class: "fr",
                  width: 16
                })
              ]))
            : _createCommentVNode("", true),
          _hoisted_7
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/icons/asta.png`),
        width: "20",
        height: "23",
        class: "pointer fl mr15"
      }, null, 8, _hoisted_12),
      _hoisted_13
    ]),
    _hoisted_14,
    (_ctx.typeSpecialArray)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeSpecialArray, (fieldDic, fieldindex) => {
            return (_openBlock(), _createElementBlock("li", {
              key: `${fieldindex}${fieldDic.field_type}`,
              onClick: ($event: any) => (_ctx.clickField(fieldDic)),
              class: "pointer",
              style: {"height":"50px","line-height":"50px","border":"1px solid #eee"}
            }, [
              _createElementVNode("img", {
                src: fieldDic.icon,
                class: "fl ml15 mt10",
                width: "28",
                height: "29"
              }, null, 8, _hoisted_17),
              _createElementVNode("p", _hoisted_18, _toDisplayString(fieldDic.name), 1),
              _hoisted_19
            ], 8, _hoisted_16))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _hoisted_20,
    _hoisted_21,
    _hoisted_22,
    _hoisted_23,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeNoneInputArray, (fieldDic, fieldindex) => {
        return (_openBlock(), _createElementBlock("li", {
          key: fieldindex,
          onClick: ($event: any) => (_ctx.clickField(fieldDic)),
          class: "pointer",
          style: {"height":"50px","line-height":"50px","border":"1px solid #eee"}
        }, [
          _createElementVNode("img", {
            src: fieldDic.icon,
            class: "fl ml15 mt8",
            width: "28",
            height: "29"
          }, null, 8, _hoisted_25),
          _createElementVNode("p", _hoisted_26, _toDisplayString(fieldDic.name), 1),
          _hoisted_27
        ], 8, _hoisted_24))
      }), 128))
    ])
  ]))
}